import React, {useState} from "react";
import './css/App.css';
import ForestDice from "./components/ForestDice";
import {Box, Button} from "@mui/material";
function App() {
    const [diceOne, setDiceOne] = useState(1);
    const [diceTwo, setDiceTwo] = useState(1);
    const getRandomArbitrary = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
    };
    const rollDice = () => {
        setDiceOne(getRandomArbitrary(1, 7));
        setDiceTwo(getRandomArbitrary(1, 7));
    };
    return (
        <React.Fragment>
        <Box className="border">
            <Box className="background">
                <Box className="headerLogo">
                    Forest Trails
                </Box>
                <Box className="main">

                    <Box className="diceContainer">
                        <Box className={`dice${diceOne} dice`}/>
                        <Box className={`dice${diceTwo} dice`}/>
                    </Box>
                    <ForestDice diceOne={diceOne} diceTwo={diceTwo} />

                    <Button variant="contained" onClick={() => rollDice()} className="button">Roll</Button>

                </Box>

            </Box>
            <Box className="pencil"/>
            <Box className="bee"/>
        </Box>
    <Box className="footer"><a href="https://www.brain-escape.co.uk" target="_blank">12</a></Box>
        </React.Fragment>);
}

export default App;
